<div>
  <!--class="lib-elevation-1"-->
  <figure>
    <div class="aspect-ratio"></div>
    <div class="content contain">
      <!-- <ngx-picture src="/assets/illustrations/ladder_transparent_bkgrd.svg"></ngx-picture> -->
      <ngx-picture src="/assets/illustrations/get-started-02.svg" [lazyLoad]="true"></ngx-picture>
    </div>
  </figure>
  <h3>One step away from a home you love.</h3>
  <p>Sign up to continue your journey and pick up where you left off anytime.</p>
  <nav class="lib-nav" [hidden]="hideNav">
    <button pTrackEvent="click" pTrackAction="signup" pTrackCategory="app_signup" class="lib-button-stroked"
      routerLink="/signup">
      <span>Sign up</span>
    </button>
    <span class="lib-spacer"></span>
    <p>Already have an account? <a pTrackEvent="click" pTrackAction="signin" pTrackCategory="app_signup"
        routerLink="/signin">Sign&nbsp;in</a></p>
  </nav>

</div>
